<h1 style="text-align: center;">Account Settings</h1>
<div style="display: flex; justify-content: center; align-items: center; gap: 10px; flex-direction: column;">
    <mat-card style="width: 100%;">
        <mat-card-header>
            <h2 mat-card-title>Social Connections</h2>
        </mat-card-header>
        <mat-card-content>
            <mat-action-list>
                <mat-list-item (click)="openVRChatAccount()">
                    <img src="/img/vrchat_icon.png" alt="VRChat" matListItemIcon>
                    <span matListItemTitle>VRChat</span>
                    <span matListItemLine>{{ accountService.account.value?.connections?.vrchat?.username }}</span>
                </mat-list-item>
                <mat-divider></mat-divider>
                <mat-list-item (click)="openPatreonAccount()">
                    <app-patreon-icon matListItemIcon></app-patreon-icon>
                    
                    <span matListItemTitle>Patreon</span>
                    @if (accountService.account.value?.connections?.patreon) {
                        <span matListItemLine>{{ accountService.account.value?.connections?.patreon?.username }} &middot; {{ accountService.account.value?.connections?.patreon?.subscriptionTier?.name }}</span>
                    } @else {
                        <span matListItemLine><i style="color: var(--mat-sys-on-surface-variant)">Not connected</i></span>
                    }
                </mat-list-item>
                <mat-divider></mat-divider>
                <mat-list-item (click)="openDiscordAccount()">
                    <mat-icon matListItemIcon>discord</mat-icon>
                    <span matListItemTitle>Discord</span>
                    <span matListItemLine>{{ accountService.account.value?.connections?.discord?.username }}</span>
                </mat-list-item>
            </mat-action-list>
        </mat-card-content>
    </mat-card>
    
    <mat-card style="width: 100%;">
        <mat-card-header>
            <h2 mat-card-title>Notification Settings</h2>
            <span mat-card-subtitle>Recieve notification on Discord via DMs from the Cult Bot</span>
        </mat-card-header>
        <mat-card-content>
            <mat-selection-list (selectionChange)="onSelectionChange($event)">
                @for (category of notificationCategories; track category.name) {
                    <div mat-subheader>
                        <div style="display: flex; align-items: center; gap: 10px;">
                            @if (category.icon == "patreon") {
                                <app-patreon-icon matListItemIcon></app-patreon-icon>
                            } @else {
                                <mat-icon matListItemIcon>{{ category.icon }}</mat-icon> 
                            }
                            <span>{{ category.name }}</span>
                        </div>
                    </div>
                    @for (subcategory of category.categories; track subcategory.name) {
                        <mat-list-option 
                            style="padding-left: 2rem;"
                            [value]="subcategory.id"
                            [selected]="isSelected(subcategory.id)">
                            @if (subcategory.icon == "patreon") {
                                <app-patreon-icon matListItemIcon></app-patreon-icon>
                            } @else {
                                <mat-icon matListItemIcon>{{ subcategory.icon }}</mat-icon> 
                            }
                            <span matListItemTitle>{{ subcategory.name }}</span>
                            <span matListItemLine>{{ subcategory.description }}</span>
                        </mat-list-option>
                    }
                }
            </mat-selection-list>
            <div style="display: flex; justify-content: flex-end; margin-top: 1rem;">
                <button mat-raised-button color="primary" (click)="saveNotificationPreferences()">Save</button>
            </div>
        </mat-card-content>
    </mat-card>

</div>